import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import VueLodash from 'vue-lodash';
import vSelect from 'vue-select';

Vue.use(VueLodash, {name: 'lodash'});
Vue.component('v-select', vSelect);

const rootElement = document.getElementById('labpersonal-app');
const rootComponent = Vue.extend(App);
new rootComponent({
    el: rootElement,
    propsData: { ...rootElement.dataset }
});

console.log(...rootElement.dataset);


// WEBPACK FOOTER //
// ./src/main.js